// src/utils/formatDate.js
import moment from 'moment-timezone';

export const formatDateconvert = (dateString) => {
  return moment.tz(dateString, 'UTC').format('DD MMM YYYY');
};
// export const formatDate = (timestamp) => {
//   return moment.utc(timestamp).format('MMM DD');
// };
// export const formatTimeInTimezone = (timestamp) => {
//   const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//   return moment.utc(timestamp).tz(userTimezone).format('hh:mm A');
// };
export const formatDate = (date) => {
  return moment.utc(date).local().format("MMM DD");
};

export const formatTimeInTimezone = (date) => {
  return moment.utc(date).local().format("hh:mm A");
};
export const formatDateUTC = (date) => {
    return moment.utc(date).format('DD/MM/YYYY');
}

